declare function require(name: string);
import { Environment } from './environments';

export interface IConfig {
    version: string;
    appVersion: string;
    mockApiVersion?: string;
}

const getNativeConfig = () => {
    // tslint:disable-next-line: no-implicit-dependencies
    return require('react-native-config').default;
};

const getNativeVersion = () => {
    // tslint:disable-next-line: no-implicit-dependencies
    return require('react-native-version-number').default;
};

const getEnvironment: () => Environment | null = () => {
    const config = getNativeConfig();
    return config ? config.env as Environment : null;
};

const getConfig = (): IConfig => {
    const version = getNativeVersion();
    const config = getNativeConfig();
    return {
        version: version.buildVersion,
        appVersion: version.appVersion,
        mockApiVersion: config ? config.mockApiVersion : null
    };
};

export { getEnvironment, getConfig };
